import React, { useEffect, useState, useCallback } from "react";
import { bindActionCreators } from "redux";
import moment from "moment";
import { connect } from "react-redux";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { search, getPath, updateTrip } from "actions/scooter/trip/actions";
import { getQR } from "actions/scooter/scooter/actions";
import MapUserTrip from "views/lib/components/maps/trip-map";
import { Card } from "react-bootstrap";
import filterTypes from "../../../data/filter-types";
import ScooterSingleTrip from "./components/scooter-single-trip";
import ModalEditScooterBillingModeTariff from "./modal-edit-scooter-billing-mode-tariff";
import getFilesUrl from "../../../helpers/getFilesUrl";
import avatarPlaceholder from "../../../images/avatar.png";

const ScooterTripHistory = ({
                              closeCustomModal,
                              openCustomModal,

                              userId,
                              search,
                              list,

                              getPath,
                              path,

                              updateTrip
                            }) => {
  const [selectedTripId, setSelectedTripId] = useState(0);
  const [qrList, setQrList] = useState({});
  const [isAllLoaded, setIsAllLoaded] = useState(false);

  const pathCoordinates = path.map(p => ({
    lng: p.longitude,
    lat: p.latitude,
  }));

  const trips = (list.content || []);
  const currentTrip = trips.find(i => i.id === selectedTripId);

  useEffect(() => {
    search(0, 100, "end,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [search, userId]);

  const handleLoadAll = (ev) => {
    ev.preventDefault();
    search(0, 100000, "end,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
    setIsAllLoaded(true);
  };

  const handleLoadQR = useCallback((scooterId) => {
    if (qrList[scooterId]) return;

    getQR(scooterId, qr => {
      if (!qr) return;
      setQrList(prevList => ({
        ...prevList,
        [scooterId]: qr
      }));
    });
  }, [qrList]);

  const handleLoadPath = useCallback((tripId) => {
    setSelectedTripId(tripId);
    getPath(tripId);
  }, [getPath]);

  const handleEdit = useCallback((tripId, tariffId) => {
    const modalObj = {
      id: `BillingModeTariff-${tripId}`,
      modalSettings: {
        size: "sm"
      },
      header: "Billing Mode Tariff",
      children: (
        <ModalEditScooterBillingModeTariff
          tariffId={tariffId}
          onSave={(newTariffId, duration) => {
            updateTrip(tripId, {
              billingModeTariff: newTariffId,
              duration
            });
            closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  }, [closeCustomModal, openCustomModal, updateTrip]);

  const photoExists = currentTrip && currentTrip.photo;

  return (
    <div style={{
      height: "calc(100vh - 145px)"
    }}>
      <div className="row h-100">
        <div className="col-3 h-100">
          <div className="userActionsList">
            {trips.map(trip => (
              <ScooterSingleTrip
                key={trip.id}
                trip={trip}
                onClick={handleLoadPath}
                onLoadQR={handleLoadQR}
                onEdit={() => handleEdit(trip.id, trip.billingModeTariff.id)}
                scooterQR={qrList[trip.scooter]}
                isSelected={selectedTripId === trip.id}
              />
            ))}
            {!isAllLoaded && <div className="d-flex justify-content-center mt-2">
              <button className="btn btn-outline-success w-100" onClick={handleLoadAll}>Load all...</button>
            </div>}
          </div>
        </div>
        <div className="col-7 h-100">
          {currentTrip ? (
            <div className="mb-1" style={{ height: 200 }}>
              {(currentTrip && currentTrip.billingModeTariff) ? (
                <Card className="mb-1">
                  <Card.Header className="p-1">Billing Tariff</Card.Header>
                  <Card.Body className="p-0">
                    <table className="table table-hover table-bordered table-light table-sm m-0">
                      <thead>
                      <tr>
                        <th>ID</th>
                        <th>Mode</th>
                        <th>Minutes</th>
                        <th>Price</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>{currentTrip.billingModeTariff.id}</td>
                        <td>{currentTrip.billingModeTariff.mode}</td>
                        <td>{currentTrip.billingModeTariff.minutes}</td>
                        <td>{currentTrip.billingModeTariff.price}</td>
                      </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              ) : null}
              {currentTrip && currentTrip.speedModeTariff ? (
                <Card>
                  <Card.Header className="p-1">Speed Tariff</Card.Header>
                  <Card.Body className="p-0">
                    <table className="table table-hover table-bordered table-light table-sm m-0">
                      <thead>
                      <tr>
                        <th>ID</th>
                        <th>Speed Mode</th>
                        <th>Speed</th>
                        <th>Price</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>{currentTrip.speedModeTariff.id}</td>
                        <td>{currentTrip.speedModeTariff.speedMode}</td>
                        <td>{currentTrip.speedModeTariff.speed}</td>
                        <td>{currentTrip.speedModeTariff.price}</td>
                      </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              ) : null}
            </div>
          ) : null}
          <div style={{ height: "calc(100% - 200px - 0.25rem)" }}>
            {pathCoordinates.length ? (
              <MapUserTrip pathCoordinates={pathCoordinates}/>
            ) : null}
          </div>
        </div>
        <div className="col-2 h-100">
          {currentTrip && Array.isArray(currentTrip.pauses) ? (
            <Card>
              <Card.Header className="p-1">Pauses</Card.Header>
              <Card.Body className="p-0">
                <table className="table table-hover table-bordered table-light table-sm m-0">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Total</th>
                  </tr>
                  </thead>
                  <tbody>
                  {currentTrip.pauses.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{moment(item.start)
                        .format("HH:mm:ss MM/DD")}</td>
                      <td>{moment(item.end)
                        .format("HH:mm:ss MM/DD")}</td>
                      <td
                        title={`${Math.round((item.end - item.start) / 1000)} seconds`}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        ~{Math.ceil((item.end - item.start) / 60000)}m
                      </td>
                    </tr>
                  ))}
                  {!currentTrip.pauses.length ? (
                    <tr>
                      <td colSpan={4} className="text-center">No data...</td>
                    </tr>
                  ) : null}
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          ) : null}

          {photoExists && (
            <div className="mb-2">
              <a href={getFilesUrl(currentTrip.photo)} target="_blank" rel="noopener noreferrer">
                <img src={currentTrip.photo
                  ? getFilesUrl(currentTrip.photo)
                  : avatarPlaceholder}
                     alt={`Trip: ${currentTrip.id}`}
                     className="img-thumbnail w-auto"
                />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooterTrip.list,
  path: state.scooterTrip.path
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  getPath: bindActionCreators(getPath, dispatch),
  updateTrip: bindActionCreators(updateTrip, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterTripHistory);



// WEBPACK FOOTER //
// ./src/views/pages/users/scooter-trip-history.js